import { useState } from "react";
import { useDispatch } from "react-redux";
import { putAlertSupplierConfimationreadCountEndpoint, putBuyerForecastHistoryNotificationsReadEndpoint, putAlertSupplierUnconfirmedConsolidatedreadCountEndpoint } from "../../../common/endpoints";
import { putAlertSupplierConfimationreadCountSlice } from "../../../redux/actions/putAlertSupplierConfimationreadCountSlice";
import { putAlertSupplierUnconfirmedConsolidatedreadCountSlice } from "../../../redux/actions/putAlertSupplierUnconfirmedConsolidatedreadCountSlice";
import { putBuyerForecastHistoryNotificationsReadSlice } from "../../../redux/actions/putBuyerForecastHistoryNotificationsReadSlice";

const cellStyle = {
    padding: "8px",
    border: "1px solid #e0e0e0",
    fontSize: "13px",
    textAlign: "left",
};

const SupplierAlertCard = ({ alertData }) => {
    const [expanded, setExpanded] = useState(false);
    const [read, setRead] = useState(!(alertData?.status === "N" || alertData?.isNew === true));
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleShowMore = async () => {
        try {
            setExpanded(!expanded);

            if (!read) {
                setLoading(true);

                const userEmail = localStorage.getItem("userEmail");
                const id = alertData?.id;

                let response;

                if (alertData?.type === "notification") {
                    response = await dispatch(
                        putAlertSupplierConfimationreadCountSlice({
                            dynamicEndpoint: `${putAlertSupplierConfimationreadCountEndpoint}/${userEmail}/${id}/read`,
                            skipUserEmailParam: true,
                        })
                    );
                } else if (alertData?.type === "consolidated") {
                    response = await dispatch(
                        putAlertSupplierUnconfirmedConsolidatedreadCountSlice({
                            dynamicEndpoint: `${putAlertSupplierUnconfirmedConsolidatedreadCountEndpoint}/${id}/read/${userEmail}`,
                            skipUserEmailParam: true,
                        })
                    );

                } else if (alertData?.type === "forecastHistory") {
                    response = await dispatch(
                        putBuyerForecastHistoryNotificationsReadSlice({
                            dynamicEndpoint: `${putBuyerForecastHistoryNotificationsReadEndpoint}/${id}/read/${encodeURIComponent(userEmail)}`,
                            skipUserEmailParam: true,
                        })
                    );
                }

                if (response?.meta?.requestStatus === "fulfilled") {
                    setRead(true);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div
            style={{
                position: "relative",
                background: "#EAF2FB",
                borderLeft: "4px solid #1976d2",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "12px",
            }}
        >
            {/* TOP ROW */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                    {alertData?.type === "obsolete" ? alertData?.title : alertData?.title}
                </div>

                {/* NEW badge */}
                {!read && (
                    <div
                        style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "#ef4444",
                            color: "#fff",
                            fontSize: "10px",
                            fontWeight: 700,
                            padding: "2px 6px",
                            borderRadius: "999px",
                        }}
                    >
                        NEW
                    </div>
                )}

                <div style={{ fontSize: "16px", color: "#333" }}>
                    {alertData?.type === "obsolete" ? alertData?.alertDate?.split("T")[0] :
                        alertData?.alertDate?.split("T")[0]
                    }
                </div>
            </div>

            {alertData?.type === "forecastHistory" && (
                <div style={{ marginTop: 10, fontSize: "16px", whiteSpace: "pre-line" }}>
                    <div dangerouslySetInnerHTML={{ __html: alertData?.description || "Forecast history export is available in My Downloads." }} />

                </div>
            )}

            {/* DESCRIPTION */}
            <div style={{ marginTop: 10, fontSize: "16px" }}>
                {alertData?.type === "consolidated" ? (
                    <>
                        Dear Supplier,
                        <br /><br />
                        This is a friendly reminder that there are still pending forecast confirmation items requiring your review in the system within the month.
                    </>
                ) : (
                    alertData?.type === "obsolete" &&
                    <>
                        Dear Supplier,
                        <br /><br />
                        This is to inform you that the forecast for the below Plant-Supplier-Material combinations has been confirmed based on your latest acknowledgement.
                        <br /><br />
                        Please find the details below:
                    </>
                )}
            </div>

            {/* TABLE */}
            {expanded && (
                <div style={{ marginTop: 12 }}>
                    {alertData?.type === "consolidated" ? (
                        <>
                            We kindly encourage you to complete the confirmation process to ensure a shared understanding of your ability to supply the forecast quantities on the required dates.
                            <br />
                            <br />
                            Thank you for your continued partnership.
                        </>
                    ) : alertData?.type === "forecastHistory" ? (
                        <div
                            style={{
                                fontSize: "16px",
                            }}
                        >
                            {alertData?.downloadUrl && (
                                <div style={{ marginTop: 10 }}>
                                    <a
                                        href={alertData.downloadUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: "#1976d2",
                                            textDecoration: "underline",
                                            fontWeight: 600,
                                        }}
                                    >
                                        Download Export File
                                    </a>
                                </div>
                            )}
                        </div>
                    ) : (
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                background: "#fff",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={cellStyle}>Coca Cola Plant</th>
                                    <th style={cellStyle}>Child Supplier</th>
                                    <th style={cellStyle}>TCCC Material Number</th>
                                    <th style={cellStyle}>Material Description</th>
                                </tr>
                            </thead>

                            <tbody>
                                {(alertData?.description || []).map((item, index) => (
                                    <tr key={index}>
                                        <td style={cellStyle}>{item.plant}</td>
                                        <td style={cellStyle}>{item.supplierName}</td>
                                        <td style={cellStyle}>{item.material}</td>
                                        <td style={cellStyle}>{item.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}

            {/* SHOW MORE / LESS */}
            <div
                onClick={handleShowMore}
                style={{
                    marginTop: 16,
                    marginBottom: 6,
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: 500,
                    opacity: loading ? 0.6 : 1,
                }}
            >
                {expanded ? "Show Less" : "Show More"}
            </div>
        </div>
    );
};

export default SupplierAlertCard;